/*
 * Добавляет в компонент метод, чтобы использовать его в шаблонах.
 * Метод использует `bem-cn-lite` – генератор имен классов по методологии БЭМ.
 * Применение - const b = useBem('name-class')
 * Документация: https://github.com/mistakster/bem-cn-lite#readme
 */
import bemCn from 'bem-cn-lite'
import { defineNuxtPlugin } from 'nuxt/app'

// Переводит классы по бэм в классы css модулей
const getCssModulesClassNames = function (style, names) {
  // Получаем массив классов
  const nameArr = names.split(' ')

  // Если в строке один класс сразу получаем новое имя
  if (nameArr.length === 1) {
    return style[names]
  }

  // Получаем модульные классы
  return nameArr
    .reduce((result, name) => {
      // Проверяем есть ли нужный класс в css модулях
      if (name in style) {
        result.push(style[name])
      }

      return result
    }, [])
    .join(' ')
}

export default defineNuxtPlugin((nuxtApp) => {
  const cfg = {
    hyphenate: false,
    methodName: 'b',
  }

  nuxtApp.vueApp.mixin({
    data() {
      return {
        [cfg.methodName]: null,
      }
    },
    created() {
      const block = this.$options.block || this.$options.name || this.name

      if (typeof block !== 'string' || !block.startsWith('ga-')) {
        this[cfg.methodName] = (name) => name

        return undefined
      }

      const generator = bemCn(block, cfg)

      this[cfg.methodName] = (...args) => {
        const classNames = generator(...args)

        // Проверяем есть ли в компоненте css modules
        if (this.$style) {
          // Если есть получаем новые имена классов
          return getCssModulesClassNames(this.$style, classNames)
        }

        return classNames
      }
    },
  })
})
